const objectToForm = (o) => {
  const form = new FormData();
  for (const key in o) {
    if (o.hasOwnProperty(key)) {
      const element = o[key];
      if (typeof element === 'object' && !(element instanceof File)) {
        form.append(key, JSON.stringify(element));
      } else form.append(key, element);
    }
  }
  return form;
};

export default objectToForm;
